(ns frontend.view.nev.oppo.event
  (:require
   [frontend.subscription :as subscription]
   [frontend.view.nev.events :as nev-events]
   [frontend.view.nev.oppo.sub :as sub]
   [re-frame.core :as rf]))

(rf/reg-event-fx
 ::on-update
 (fn [{db :db} [_ entities initial-data-loaded?]]
   (let [id->entity (->> entities
                         (reduce
                          (fn [id->entity entity]
                            (if (:common/disabled? entity)
                              (dissoc id->entity (:db/id entity))
                              (assoc id->entity (:db/id entity) entity)))
                          {}))]
     {:db (-> db
              (assoc ::sub/initial-data-loaded? initial-data-loaded?)
              (update ::sub/id->entity merge id->entity))})))

(rf/reg-event-fx
 ::open-oppo-view-subscription
 (fn [{db :db} [_ oppo-id]]
   (subscription/open ::oppo
                      :view-subscription/oppo
                      {:oppo-id oppo-id}
                      (fn [{:keys [entities initial-data?]}]
                        (nev-events/updates-to-session-state entities)
                        (rf/dispatch [::on-update entities initial-data?])
                        :ok)) ;; :ok ?
   {:db (dissoc db ::sub/initial-data-loaded?)}))

(rf/reg-event-fx
 ::close-oppo-view-subscription
 (fn [_ _]
   (subscription/close ::oppo)
   {}))
